// booking/services/instrumentedApi.ts
import { breadcrumb, captureBookingException } from './sentryBooking'

export async function instrumentedCall<T>(
  name: string,
  fn: () => Promise<T>,
  extra?: Record<string, unknown>
): Promise<T> {
  const start = typeof performance !== 'undefined' ? performance.now() : Date.now()
  breadcrumb(`api.${name}.start`, extra, 'booking.api')

  try {
    const res = await fn()
    const end = typeof performance !== 'undefined' ? performance.now() : Date.now()
    const ms = Math.round(end - start)
    breadcrumb(`api.${name}.success`, { ...extra, ms }, 'booking.api')
    return res
  } catch (err) {
    const end = typeof performance !== 'undefined' ? performance.now() : Date.now()
    const ms = Math.round(end - start)
    breadcrumb(`api.${name}.fail`, { ...extra, ms }, 'booking.api', 'error')
    captureBookingException(err, `API_${name.toUpperCase()}_FAILED`, { ...extra, ms }, ['booking', `api.${name}`])
    throw err
  }
}
